import ExhibitionContainer from "../../../Component/Application/Exhibition/ExhibitionContainer";

const Exhibition = () => {
    return (
        <div className="page-body">
            <ExhibitionContainer />
        </div>
    );
};

export default Exhibition;